const THREE_MINUTES = 1000 * 60 * 3;

export { THREE_MINUTES };
